export function formatStockCountQuantity(value, { empty = "—", maxFractionDigits = 4 } = {}) {
  if (value === null || value === undefined || value === "") return empty;
  const number = Number(value);
  if (!Number.isFinite(number)) return empty;
  return number.toLocaleString("es-AR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxFractionDigits,
  });
}

export function formatSignedStockCountQuantity(value, { maxFractionDigits = 4 } = {}) {
  if (value === null || value === undefined || value === "") return "—";
  const number = Number(value);
  if (!Number.isFinite(number)) return "—";
  const formatted = Math.abs(number).toLocaleString("es-AR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxFractionDigits,
  });
  if (number > 0) return `+${formatted}`;
  if (number < 0) return `-${formatted}`;
  return formatted;
}
